import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  RiMailFill,
  RiLock2Fill,
  RiArrowRightLine,
  RiShieldCheckLine,
} from "react-icons/ri";
import { Formik } from "formik";
import * as Yup from "yup";
import { useAuthContext } from "../../context/AuthContext";
import { Checkbox, Modal, MyInput } from "../../ui";
import Loader from "../../utils/Loader/Loader";
import ForgotPassModal from "../ForgotPassModal/ForgotPassModal";

import "./loginModal.scss";

const logo = require("../../assets/logo-with-bottom-name.png");
const man = require("../../assets/businessman.png");

const REMEMBER_KEY = "REMEMBER_PASS";

const schemas = Yup.object().shape({
  email: Yup.string()
    .email("Зөв форматаар бичнэ үү!")
    .matches(/[a-z0-9]+@[a-z]+\.[a-z]{2,3}/, "Зөв форматаар бичнэ үү!")
    .required("Хоосон байна!"),
  password: Yup.string()
    .min(8, "Хамгийн багадаа 8 тэмдэгт байх ёстой!")
    .required("Хоосон байна!"),
});

const LoginModal = ({ visible, setVisible, onOpenSignup }) => {
  const { isLoading, loginHandler } = useAuthContext();

  const [savedValues, setSavedValues] = useState({
    email: "",
    password: "",
  });
  const [rememberMe, setRememberMe] = useState(false);
  const [visibleForgot, setVisibleForgot] = useState(false);

  useEffect(() => {
    const raw = localStorage.getItem(REMEMBER_KEY);

    if (raw) {
      try {
        const parsed = JSON.parse(raw);
        setSavedValues(parsed?.values || { email: "", password: "" });
        setRememberMe(true);
      } catch (e) {
        localStorage.removeItem(REMEMBER_KEY);
      }
    }
  }, []);

  const initialValues = useMemo(
    () => ({
      email: savedValues?.email || "",
      password: savedValues?.password || "",
    }),
    [savedValues],
  );

  const rememberPassOnChange = (checked, values) => {
    setRememberMe(checked);

    if (checked) {
      localStorage.setItem(REMEMBER_KEY, JSON.stringify({ values }));
    } else {
      localStorage.removeItem(REMEMBER_KEY);
    }
  };

  const handleFormSubmit = (vals) => {
    if (rememberMe) {
      localStorage.setItem(REMEMBER_KEY, JSON.stringify({ values: vals }));
    }
    loginHandler(vals);
  };

  return (
    <Modal visible={visible} onCancel={setVisible}>
      <ForgotPassModal visible={visibleForgot} setVisible={setVisibleForgot} />

      <div className={`loginModal ${visibleForgot ? "forgot-open" : ""}`}>
        <div className="loginModal__left">
          <div className="loginModal__brand">
            <img className="loginModal__brand-logo" src={logo} alt="logo" />

            {/* <div className="loginModal__brand-copy">
              <span className="loginModal__badge">
                <RiShieldCheckLine />
                Баталгаажсан
              </span>
            </div> */}
          </div>

          <div className="loginModal__illustrationWrap">
            <div className="loginModal__glow" />
            <img className="loginModal__man" src={man} alt="illustration" />
          </div>
        </div>

        <div className="loginModal__right">
          <div className="loginModal__panel">
            <div className="loginModal__heading">
              <h3>Нэвтрэх</h3>
              <p>Тавтай морил. Өөрийн бүртгэлээр нэвтэрнэ үү.</p>
            </div>

            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={schemas}
              onSubmit={handleFormSubmit}
            >
              {({
                values,
                errors,
                touched,
                setFieldTouched,
                handleChange,
                handleSubmit,
              }) => (
                <form className="loginModal__form" onSubmit={handleSubmit}>
                  <div className="loginModal__field">
                    <label>И-Мэйл</label>
                    <MyInput
                      icon={<RiMailFill />}
                      placeholder="example@email.com"
                      name="email"
                      value={values.email}
                      onChange={(e) => {
                        const value = e.target.value.toLowerCase();

                        handleChange({
                          target: {
                            name: "email",
                            value,
                          },
                        });

                        if (rememberMe) {
                          rememberPassOnChange(true, {
                            ...values,
                            email: value,
                          });
                        }
                      }}
                      onBlur={() => setFieldTouched("email")}
                      touched={touched.email}
                      errorText={errors.email}
                    />
                  </div>

                  <div className="loginModal__field">
                    <label>Нууц үг</label>
                    <MyInput
                      icon={<RiLock2Fill />}
                      placeholder="••••••••"
                      name="password"
                      value={values.password}
                      type="password"
                      onChange={(e) => {
                        handleChange(e);
                        if (rememberMe) {
                          rememberPassOnChange(true, {
                            ...values,
                            password: e.target.value,
                          });
                        }
                      }}
                      onBlur={() => setFieldTouched("password")}
                      touched={touched.password}
                      errorText={errors.password}
                    />
                  </div>

                  <div className="loginModal__form-help">
                    <Checkbox
                      checked={rememberMe}
                      onChange={(e) =>
                        rememberPassOnChange(e.target?.checked, values)
                      }
                    >
                      Намайг сана
                    </Checkbox>

                    <button
                      type="button"
                      className="loginModal__forgotBtn"
                      onClick={() => setVisibleForgot(true)}
                    >
                      Нууц үгээ мартсан уу?
                    </button>
                  </div>

                  {isLoading ? (
                    <div className="loginModal__loaderWrap">
                      <Loader mini />
                    </div>
                  ) : (
                    <button type="submit" className="loginModal__submit">
                      <span>Нэвтрэх</span>
                      <RiArrowRightLine />
                    </button>
                  )}
                </form>
              )}
            </Formik>

            <div className="loginModal__divider">
              <span>эсвэл</span>
            </div>

            <p className="loginModal__signup flex gap-2 justify-center">
              Бүртгэлгүй юу?
              {onOpenSignup ? (
                <button
                  type="button"
                  className="no-button text-[#4f46e5]!"
                  onClick={() => {
                    setVisible(false);
                    onOpenSignup();
                  }}
                >
                  Бүртгүүлэх
                </button>
              ) : (
                <Link to="/signup">Бүртгүүлэх</Link>
              )}
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default LoginModal;
